var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "work-time-calendar-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("ChartDoddleIcon"),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("report.agentWorkTimeCalendar"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-wrapper" },
        [
          !_vm.tableMode
            ? _c(
                "div",
                [
                  _vm.isOneDay()
                    ? _c("UserStatusBarChart", {
                        attrs: {
                          title: _vm.translatedTitle,
                          "user-names": _vm.calendarUsers().map(function (x) {
                            return x.name
                          }),
                          series: _vm.calculateSingleDayBarSeries(),
                        },
                      })
                    : _c(
                        "div",
                        { staticClass: "moreThanDay" },
                        [
                          _c("h5", [_vm._v(_vm._s(_vm.calendarTitle))]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-1",
                              staticStyle: { "align-self": "flex-end" },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "mb-3",
                                  model: {
                                    value: _vm.selectedCalendarUser,
                                    callback: function ($$v) {
                                      _vm.selectedCalendarUser = $$v
                                    },
                                    expression: "selectedCalendarUser",
                                  },
                                },
                                _vm._l(_vm.calendarUsers(), function (user) {
                                  return _c(
                                    "option",
                                    {
                                      key: user._id,
                                      domProps: { value: user._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(user.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.selectedCalendarUser
                            ? _c("UserStatusCalendarPieChart", {
                                attrs: {
                                  title: _vm.calendarTitle,
                                  "sub-title": "Work Hour Distribution Daily",
                                  "start-date": _vm.filters.startDate,
                                  "end-date": _vm.filters.endDate,
                                  "scatter-data": _vm.getCalendarScatterData(),
                                  "pie-series": _vm.getCalendarPieSeries(),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                ghost: "",
                                small: "",
                                "class-names": "btnLeft",
                              },
                              on: { click: _vm.nextUser },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("chevron_left"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                ghost: "",
                                small: "",
                                "class-names": "btnRight",
                              },
                              on: { click: _vm.prevUser },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("chevron_right"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tableMode
            ? _c("TableView", {
                attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }